<template>
  <div class="cards-container">
    <div class="cards-content">
      <div class="item">
        <div>{{lastDate ? lastDate.year : ''}}</div>
        <div>{{lastDate ? lastDate.month : ''}}</div>
        <div>{{lastDate ? lastDate.day : ''}}</div>
      </div>
      <div class="cards-grid" v-if="allData.length > 0">
        <!-- 固定循环16个卡片 -->
        <div 
          class="card" 
          v-for="i in 16" 
          :key="i"
          @mouseenter="pauseCard(i)"
          @mouseleave="resumeCard(i)"
        >
          <div class="card-viewport">
            <div 
              class="card-slider"
              :class="{ 'animating': isAnimating[i] }"
              :style="{ transform: `translateY(-${sliderPosition[i]}px)` }"
            >
              <!-- 当前数据面板 -->
              <div class="card-panel">
                <div class="data-title pc">{{ currentData[i] ? currentData[i].name : '-' }}({{ currentData[i] ? currentData[i].code : '-' }})</div>
                <div class="data-title mobile">
                  <p>{{ currentData[i] ? currentData[i].name : '-' }}</p>
                  <p>{{ currentData[i] ? currentData[i].code : '-' }}</p>
                </div>
                <div class="data-value">{{ currentData[i] ? currentData[i].todaySettle : '-' }}</div>
                <div class="data-change" :style="{color: getChangeColor(currentData[i])}">
                  <span>{{ getChangeValue(currentData[i]) }}</span>
                  <span v-if="showPercent(currentData[i])">
                    <i v-if="isRise(currentData[i])" style="color: red" class="el-icon-top"></i>
                    <i v-if="isFall(currentData[i])" style="color: green" class="el-icon-bottom"></i>
                    {{ getPercentValue(currentData[i]) }}%
                  </span>
                </div>
              </div>
              
              <!-- 下一条数据面板 -->
              <div class="card-panel">
                <div class="data-title pc">{{ nextData[i] ? nextData[i].name : '-' }}({{ nextData[i] ? nextData[i].code : '-' }})</div>
                <div class="data-title mobile">
                  <p>{{ nextData[i] ? nextData[i].name : '-' }}</p>
                  <p>{{ nextData[i] ? nextData[i].code : '-' }}</p>
                </div>
                <div class="data-value">{{ nextData[i] ? nextData[i].todaySettle : '-' }}</div>
                <div class="data-change" :style="{color: getChangeColor(nextData[i])}">
                  <span>{{ getChangeValue(nextData[i]) }}</span>
                  <span v-if="showPercent(nextData[i])">
                    <i v-if="isRise(nextData[i])" style="color: red" class="el-icon-top"></i>
                    <i v-if="isFall(nextData[i])" style="color: green" class="el-icon-bottom"></i>
                    {{ getPercentValue(nextData[i]) }}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-state" v-else>
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { futuresCode } from './futures-code'
export default {
  name: 'TwoRowCardsWithAnimation',
  props: {
    lastDate: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 初始化16个元素的状态对象（固定16个卡片）
    const init16Obj = (defaultValue) => {
      const obj = {};
      for (let i = 1; i <= 16; i++) {
        obj[i] = defaultValue;
      }
      return obj;
    };

    return {
      futuresCode,
      allData: [],
      // 固定16个卡片的当前索引
      currentIndices: init16Obj(0),
      // 固定16个卡片的滑动位置
      sliderPosition: init16Obj(0),
      // 固定16个卡片的动画状态
      isAnimating: init16Obj(false),
      // 固定16个卡片的运行状态
      isRunning: init16Obj(true),
      globalTimer: null,
      cardHeight: 100 // 卡片高度（与CSS一致）
    }
  },
  computed: {
    currentData() {
      const data = {};
      if (!this.allData.length) return data;

      // 16个卡片循环取数据（不足时重复）
      for (let i = 1; i <= 16; i++) {
        const idx = this.currentIndices[i] % this.allData.length;
        data[i] = this.allData[idx];
      }
      return data;
    },
    nextData() {
      const data = {};
      if (!this.allData.length) return data;

      // 下一条数据 = 当前索引 + 1（循环）
      for (let i = 1; i <= 16; i++) {
        const currentIdx = this.currentIndices[i] % this.allData.length;
        const nextIdx = (currentIdx + 1) % this.allData.length;
        data[i] = this.allData[nextIdx];
      }
      return data;
    }
  },
  mounted() {
    this.getAllData();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.globalTimer) {
        clearInterval(this.globalTimer);
        this.globalTimer = null;
      }
    },
    extractLetters(str) {
      if (!str) return '';
      const letters = str.match(/[a-zA-Z]+/g);
      return letters ? letters.join('') : '';
    },
    getAllData() {
      this.allData = [];

      this.$http({
        url: this.$http.adornUrl('/crmapi/bas/bulkFutures/lastData'),
        method: 'get'
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          let array = data.result || [];
          array = array.filter(item => item && item.contractCode); // 过滤无效数据

          this.allData = array.map(item => {
            let futItem = this.futuresCode.find(fut => 
              this.extractLetters(item.contractCode) === fut.value
            );
            return {
              ...item,
              name: futItem ? `${futItem.label}` : item.contractCode,
              code: futItem ? `${futItem.value}` : item.contractCode
            };
          });

          this.$emit('changeData', this.allData);
          this.startGlobalTimer(); // 有数据就启动动画
        } else {
          this.$message.error(data ? data.message : '获取数据失败');
        }
      }).catch(err => {
        console.error('请求失败:', err);
        this.$message.error('获取数据失败');
      });
    },
    // 启动全局定时器（固定16个卡片的翻转逻辑）
    startGlobalTimer() {
      this.clearTimer();
      if (this.allData.length === 0) return;

      // 恢复原有节奏：每2.5秒随机翻转2-3个卡片
      this.globalTimer = setInterval(() => {
        this.triggerRandomFlip();
      }, 2500);
    },
    // 随机选择2-3个可用卡片翻转（适配16个卡片）
    triggerRandomFlip() {
      const availableCards = [];
      // 遍历16个卡片，筛选可用卡片
      for (let i = 1; i <= 16; i++) {
        if (this.isRunning[i] && !this.isAnimating[i]) {
          availableCards.push(i);
        }
      }

      if (availableCards.length === 0) return;

      // 保持原有逻辑：随机选2-3个
      const flipCount = Math.min(
        Math.random() > 0.5 ? 3 : 2,
        availableCards.length
      );
      // 随机打乱并选择前N个
      const shuffled = [...availableCards].sort(() => 0.5 - Math.random());
      const toFlip = shuffled.slice(0, flipCount);

      toFlip.forEach(cardIndex => this.flipCard(cardIndex));
    },
    // 卡片翻转动画（核心逻辑，确保触发）
    flipCard(cardIndex) {
      if (this.isAnimating[cardIndex] || this.allData.length === 0) return;

      // 标记动画状态，触发CSS过渡
      this.isAnimating[cardIndex] = true;
      // 向上滑动一个卡片高度（与CSS高度一致）
      this.sliderPosition[cardIndex] = this.cardHeight;

      // 动画结束后更新索引并重置（400ms与CSS过渡时间匹配）
      setTimeout(() => {
        // 更新当前索引（循环+1）
        this.currentIndices[cardIndex] = (this.currentIndices[cardIndex] + 1) % this.allData.length;
        // 重置动画状态和位置（关闭过渡）
        this.isAnimating[cardIndex] = false;
        this.sliderPosition[cardIndex] = 0;
      }, 400);
    },
    // 鼠标悬浮暂停
    pauseCard(cardIndex) {
      this.isRunning[cardIndex] = false;
    },
    // 鼠标离开恢复
    resumeCard(cardIndex) {
      this.isRunning[cardIndex] = true;
    },
    // 辅助方法：计算变化颜色
    getChangeColor(data) {
      if (!data) return '';
      const today = Number(data.todaySettle) || 0;
      const yesterday = Number(data.yesterdaySettle) || 0;
      return today < yesterday ? 'green' : today > yesterday ? 'red' : '';
    },
    // 辅助方法：计算变化值
    getChangeValue(data) {
      if (!data) return '0';
      const today = Number(data.todaySettle) || 0;
      const yesterday = Number(data.yesterdaySettle) || 0;
      return Number((today - yesterday).toFixed(2));
    },
    // 辅助方法：是否显示百分比
    showPercent(data) {
      if (!data) return false;
      return Number(data.yesterdaySettle) !== 0 && Number(data.todaySettle) !== 0;
    },
    // 辅助方法：是否上涨
    isRise(data) {
      if (!data) return false;
      return Number(data.todaySettle) > Number(data.yesterdaySettle);
    },
    // 辅助方法：是否下跌
    isFall(data) {
      if (!data) return false;
      return Number(data.todaySettle) < Number(data.yesterdaySettle);
    },
    // 辅助方法：计算百分比
    getPercentValue(data) {
      if (!data) return '0';
      const today = Number(data.todaySettle) || 0;
      const yesterday = Number(data.yesterdaySettle) || 0;
      if (yesterday === 0) return '0';
      return Math.abs(Number(((today - yesterday) / yesterday * 100).toFixed(2)));
    }
  }
}
</script>

<style lang="scss" scoped>
.cards-container {
  padding: 20px 0;
}

.cards-content{
  display: flex;
  background-color: white;
  .item{
    text-align: center;
    line-height: 48px;
    font-size: 1.2rem;
    width: 60px;
    padding: 30px 0;
    font-weight: bold;
  }
}

/* 固定两行八列，确保16个卡片布局 */
.cards-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 5px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
}

.empty-state {
  flex: 1;
  text-align: center;
  padding: 50px 0;
  color: #999;
}

.card {
  width: 100%;
  max-width: 120px;
  height: 100px; /* 与cardHeight一致 */
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
  margin: 0 auto;
}

.card-viewport {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.card-slider {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/* 动画触发关键：确保过渡效果生效 */
.animating {
  transition: transform 0.4s ease-out !important;
}

.card-panel {
  width: 100%;
  height: 100px; /* 与卡片高度一致 */
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: white;
}

.data-title {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 6px;
  text-align: center;
  white-space: nowrap;
  // overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
}

.data-value {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 4px;
}

.data-change {
  font-size: 0.8rem;
  text-align: center;
  font-weight: 500;
}

.mobile{
  display: none;
}
.pc{
  display: block;
}

@media screen and (max-width: 1200px) {
  .card-panel{
    height: 120px !important; /* 与卡片高度一致 */
  }
  .card{
    height: 120px !important; /* 与卡片高度一致 */
  }
  .pc{
    display: none;
  }
  .mobile{
    display: block;
  }
  .data-title{
    font-size: 1.1rem !important;
  }
  .data-value{
    font-size: 1.3rem !important;
  }
  .data-change{
    font-size: 1rem !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/indexCard.vue